import styles from "./Service.module.scss";
import * as React from "react";
import {FC, useCallback, useContext, useEffect, useMemo} from "react";

import {Button} from "devextreme-react";
import {AppStoreContext} from "../../Stores/AppStore";
import {observer} from "mobx-react";
import {MaintenanceDTO, SortingItem} from "../../Models/ApiModels";

import DateTimeService from "../../Services/DateTimeService";
import {NoDataHint, SelectMachineHint} from "./components/Hints";
import {AppRouting} from "../../AppConstants";
import {useHistory} from "react-router-dom";
import {GetOptionsFromList, ListFilterSorting} from "./components/ListFilterSorting";

const Tasks = observer(() => {
    const context = useContext(AppStoreContext);
    const history = useHistory();
    const {loadTasks, filtersStore, tasksList, checklist} = context;

    const taskSortingItems: SortingItem[] = useMemo(() => [
        {key: 'description', label: 'Description'},
        {key: 'due', label: 'Due'},
        {key: 'time', label: 'Time'},
    ], []);

    const taskFilterItems: SortingItem[] = useMemo(() => [
        {key: 'status', label: 'Status', options: GetOptionsFromList(checklist?.map(t => t.status))},
        {
            key: 'type',
            label: 'Type',
            options: [{label: 'Scheduled', value: 'isScheduled'}, {label: 'Data Based', value: 'dataBased'}]
        },
        {key: 'isRecurring', label: 'Recurring', options: [{label: 'Yes', value: true}, {label: 'No', value: false}]},
        {key: 'isAlmostDue', label: 'Almost Due', options: [{label: 'Yes', value: true}, {label: 'No', value: false}]},
    ], [checklist]);


    useEffect(() => {
        void loadTasks();
    }, [filtersStore.selected, loadTasks]);

    const _newItem = useCallback(() => {
        history.push(`${AppRouting.Tasks}/new`);
    }, [history]);

    if (!filtersStore.selected.plant) {
        return <SelectMachineHint/>;
    }

    return (
        <>
            <div className={styles.title}>
                Checklist
                <div className={styles.mlAuto}>
                    <Button className={styles.action} onClick={_newItem}>
                        Add New Task
                    </Button>
                </div>
            </div>
            <ListFilterSorting
                sortingItems={taskSortingItems}
                filterItems={taskFilterItems}
            />
            <div className={styles.list}>
                {tasksList !== null && !tasksList.length &&
                    <NoDataHint message="Empty checklist data"/>}
                {!!tasksList?.length &&
                    <div className={styles.listContainer}>
                        {tasksList.map(task => <TaskItem key={task.taskId} task={task}/>)}
                    </div>
                }
            </div>
        </>
    );
});


const TaskItem: FC<{ task: MaintenanceDTO }> = observer(({task}) => {
    const history = useHistory();
    const {time, description, taskId} = task;
    const value = task.value || 0;
    const initialValue = task.initialValue || 0;
    const valueDelta = task.valueDelta || 0;
    const due = task.due || 0;
    const currentValue = Math.round(value - initialValue);
    const label = task.timeDelta ? `${Math.round(due * 100)}%` : `${currentValue}/${valueDelta || 0}`;

    const _onClick = useCallback(() => {
        history.push(`${AppRouting.Tasks}/${taskId}`);
    }, [history, taskId]);

    return (
        <div className={styles.listItem} onClick={_onClick}>
            <div className={styles.listDesc}>{description}</div>
            <div className={styles.listComment}>
                <b>{DateTimeService.format(time)}</b>
            </div>
            <div className={styles.listBar}>
                <div className={styles.listValue}>{label}</div>
                <div className={`${styles.listProgress} ${due >= 1 ? styles.full : ''}`}
                     style={{width: `${(due >= 1 ? 1 : due) * 100}%`}}></div>
            </div>
        </div>
    );
});


export default Tasks;